import React from 'react';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';

export function LeftArrow() {
  const { isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators, initComplete } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !initComplete || (initComplete && isFirstItemVisible),
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    <div
      onClick={() => scrollPrev()}
      style={{
        cursor: 'pointer',
        display: disabled ? 'none' : 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        right: '1%',
        userSelect: 'none',
      }}
    >
      <LeftCircleOutlined style={{ fontSize: '30px', color: '#c1c1c1' }} />
    </div>
  );
}

export function RightArrow() {
  const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isLastItemVisible,
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
    <div
      onClick={() => scrollNext()}
      style={{
        cursor: 'pointer',
        display: disabled ? 'none' : 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        right: '1%',
        userSelect: 'none',
      }}
    >
      <RightCircleOutlined style={{ fontSize: '30px', color: '#c1c1c1' }} />
    </div>
  );
}
